/*jslint node: true*/
"use strict";

var ko = require("pli/knockout");


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// "FormattedBehaviour" class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
// Adds formatted observable in places where
// raw was used to access the formatted value.
function FormattedBehaviour() {
    return this;
}

//-------------------------------------------
FormattedBehaviour.prototype.init = function FormattedBehaviourInit() {
    this.formatted = ko.observable("");
    this.subscribe(FormattedBehaviour.prototype._valueUpdated, this);
    FormattedBehaviour.prototype._valueUpdated.call(this);
};

//-------------------------------------------
FormattedBehaviour.prototype._valueUpdated = function FormattedBehaviourValueUpdated() {
    this.formatted(this.format());
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Export
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
module.exports = new FormattedBehaviour();



//////////////////
// WEBPACK FOOTER
// ./app/ko-behaviours-formatted/formatted.js
// module id = 519
// module chunks = 49